class DailyRoutineController {

    constructor() {
        this.model = plannerApplication.studyPlannerProfile.getDailyRoutine();
        this.view = new DailyRoutineView();
        this.view.morningSlider.val(this.model.getBeginDay());
        this.view.eveningSlider.val(this.model.getEndDay());
        timeRangeUpdated(this.view.morningSlider);
        timeRangeUpdated(this.view.eveningSlider);
        this.view.morningSlider.change(this.onUpdated.bind(this));
        this.view.eveningSlider.change(this.onUpdated.bind(this));
        this.onUpdated();
    };

    onUpdated() {
        let morningMin = this.view.morningSlider.val();
        let eveningMin = this.view.eveningSlider.val();
        this.model.updateTimes(morningMin, eveningMin);
        plannerApplication.userDataUpdated();
    };

}
